import React from "react";

/**
 * CheckmarkGreen — verbatim web port of the iOS gradient checkmark
 * (client-native/src/ui/atoms/visual/CheckmarkGreen.tsx). react-native-svg
 * elements map 1:1 onto DOM <svg> primitives; paths/gradients are unchanged.
 */
interface CheckmarkGreenProps {
  size?: number;
}

const CheckmarkGreen: React.FC<CheckmarkGreenProps> = ({ size = 24 }) => {
  const MAIN =
    "M260.354 92.7037C271.433 104.461 270.883 122.972 259.127 134.051L125.459 260.011C113.837 270.963 95.5781 270.569 84.4392 259.126L28.0655 201.21C16.7977 189.635 17.0475 171.116 28.6234 159.848C40.1992 148.581 58.7176 148.83 69.9853 160.406L106.285 197.698L219.007 91.4762C230.763 80.3974 249.275 80.947 260.354 92.7037Z";
  const RIGHT =
    "M219.007 91.4767C230.764 80.3979 249.276 80.9475 260.354 92.7042C271.433 104.461 270.883 122.972 259.127 134.051L125.459 260.011C119.955 265.197 112.963 267.838 105.943 267.967V197.347L106.285 197.698L219.007 91.4767Z";

  return (
    <svg width={size} height={size} viewBox="0 32 288 288" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d={MAIN} fill="#5DC862" />
      <path fillRule="evenodd" clipRule="evenodd" d={MAIN} fill="url(#gL0)" />
      <path fillRule="evenodd" clipRule="evenodd" d={MAIN} fill="url(#gR1)" />
      <path fillRule="evenodd" clipRule="evenodd" d={MAIN} fill="url(#gR2)" fillOpacity={0.8} />
      <path d={RIGHT} fill="url(#gL3)" />
      <path d={RIGHT} fill="url(#gR4)" />
      <path d={RIGHT} fill="url(#gR5)" />
      <path d={RIGHT} fill="url(#gR6)" />
      <path d={RIGHT} fill="url(#gR7)" fillOpacity={0.8} />
      <defs>
        <linearGradient id="gL0" x1="96.4789" y1="183.497" x2="52.0723" y2="227.904" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5D9858" />
          <stop offset={0.240385} stopColor="#8CCF90" />
          <stop offset={0.6875} stopColor="#42EC48" />
          <stop offset={1} stopColor="#35BE40" />
        </linearGradient>
        <radialGradient id="gR1" cx={0} cy={0} r={1} gradientUnits="userSpaceOnUse" gradientTransform="translate(81.9688 211.086) rotate(47.1984) scale(91.3623 91.3623)">
          <stop offset={0.568763} stopColor="#357334" stopOpacity={0} />
          <stop offset={0.862826} stopColor="#3B6A36" />
        </radialGradient>
        <radialGradient id="gR2" cx={0} cy={0} r={1} gradientUnits="userSpaceOnUse" gradientTransform="translate(108.072 250.273) rotate(-90) scale(18.1092 24.3692)">
          <stop offset={0.0961684} stopColor="#4DFE47" />
          <stop offset={0.846473} stopColor="#47FE59" stopOpacity={0} />
        </radialGradient>
        <linearGradient id="gL3" x1="138.191" y1="161.556" x2="187.129" y2="213.444" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B763B" />
          <stop offset={0.225962} stopColor="#5EA963" />
          <stop offset={0.522977} stopColor="#69C166" />
          <stop offset={0.735806} stopColor="#57D850" />
          <stop offset={0.894873} stopColor="#35BE37" />
        </linearGradient>
        <radialGradient id="gR4" cx={0} cy={0} r={1} gradientTransform="matrix(16.7695 -23.1699 23.1701 16.7693 251.547 99.6395)" gradientUnits="userSpaceOnUse">
          <stop offset={0.1767} stopColor="#A5D898" />
          <stop offset={1} stopColor="#7BCC7A" stopOpacity={0} />
        </radialGradient>
        <radialGradient id="gR5" cx={0} cy={0} r={1} gradientUnits="userSpaceOnUse" gradientTransform="translate(102.11 218.18) rotate(90) scale(27.2519 18.7359)">
          <stop offset={0.366279} stopColor="#90CF8C" />
          <stop offset={1} stopColor="#63B563" stopOpacity={0} />
        </radialGradient>
        <radialGradient id="gR6" cx={0} cy={0} r={1} gradientTransform="matrix(1.97156 196.169 -173.514 77.975 175.619 217.985)" gradientUnits="userSpaceOnUse">
          <stop offset={0.568763} stopColor="#347335" stopOpacity={0} />
          <stop offset={0.862826} stopColor="#3E6A36" />
        </radialGradient>
        <radialGradient id="gR7" cx={0} cy={0} r={1} gradientUnits="userSpaceOnUse" gradientTransform="translate(105.943 249.305) rotate(-90) scale(19.6073 24.3827)">
          <stop offset={0.0961684} stopColor="#47FE5F" />
          <stop offset={0.846473} stopColor="#47FE59" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default CheckmarkGreen;
